import type { Map as MlMap } from "maplibre-gl";
import { isLight, onThemeIcons, putImage } from "./theme";

// owner-approved storm icon (do not redesign) — rasterised to an addImage symbol "storm-icon".
// Shared by the live storms layer and the past-storm player (kept apart from storms.ts so the
// past-storm module never pulls in the summary store — v0.9.6 C5).
const STORM_SVG = `<svg viewBox="-26 -22 52 44" xmlns="http://www.w3.org/2000/svg"><circle r="11" fill="#0b1220" stroke="#E24B4A" stroke-width="3"/><path d="M0 -11q14 -10 22 2M0 11q-14 10 -22 -2" fill="none" stroke="#E24B4A" stroke-width="3" stroke-linecap="round"/><circle r="3" fill="#E24B4A"/></svg>`;

// v0.9.9 B5 light variant: same shape — light centre, deeper red ring
const STORM_SVG_LIGHT = STORM_SVG.replace('fill="#0b1220"', 'fill="#ffffff"').replace(/#E24B4A/g, "#C21F1E");

async function drawStormIcon(map: MlMap): Promise<void> {
  try {
    const img = new Image(); img.src = "data:image/svg+xml;utf8," + encodeURIComponent(isLight() ? STORM_SVG_LIGHT : STORM_SVG);
    await img.decode();
    const c = document.createElement("canvas"); c.width = 104; c.height = 88;
    const ctx = c.getContext("2d")!; ctx.drawImage(img, 0, 0, 104, 88);
    putImage(map, "storm-icon", ctx.getImageData(0, 0, 104, 88), { pixelRatio: 2 });
  } catch { /* icon optional; track still renders */ }
}
let themed = false;
export async function ensureStormIcon(map: MlMap): Promise<void> {
  if (!themed) { themed = true; onThemeIcons(() => { if (map.hasImage("storm-icon") || map.getLayer("storm-cur-icon")) void drawStormIcon(map); }); }
  if (map.hasImage("storm-icon")) return;
  await drawStormIcon(map);
}
